/**
 * 系统应用
 *
 * @author yubaoshan
 * @date 2020/5/26 19:06
 */
 import { axios } from '@/utils/request'

 /**
  * 登录
  *
  * @author yubaoshan
  * @date 2020/5/26 19:06
  */
 export function login (parameter) {
   return axios({
     url: 'Api/login2',
     method: 'post',
     data: parameter
   })
 }
 
/**
 * 登出
 *
 * @author yubaoshan
 * @date 2020/5/26 19:07
 */
export function logout (parameter) {
  return axios({
    url: 'Api/logout',
    method: 'get',
    params: parameter
  })
}
